module.exports = __webpack_public_path__ + "img/20200229203509360截图20200229202651459.d08ce48f.jpg";